<template>

    <nav-bar :returnAction="true" :pageName="'Indicadores'" @return="$router.push(`/patients`)" />
    
    <main-container :onlyNav="true">
    
        <div class="d-flex justify-content-center mb-5">
            <h5 class="fw-bold">{{patientStore.patient.name}}</h5>
        </div>
                        
        <div class="row d-flex justify-content-center" v-for="(obj, index) in  patientStore.getPatientHumorIndicatorsOutput" :key="index">
            <div class="col chart-wrapper">
                <single-line-chart :chartId="index" :label="obj.dataSets?.label" :chartData="obj.dataSets?.data" :chartLabels="obj?.labels" :options="options"></single-line-chart>
            </div>
        </div>                
    
    </main-container>
    
</template>

<script>
import SingleLineChart from "../../components/Charts/SingleLineChart.vue";
import { usePatientStore } from "../../store/patient";
import { convertHumor } from "../../services/formatters";

export default {
    name:"PatientIndicatorReadingView",    
    inject:["mySpinner"],
    components: {        
        SingleLineChart,
    },
    props: {
        patientId: {
            type:String
        },       
    },
    setup() {        
        const patientStore = usePatientStore();
        return { patientStore }
    },
    async mounted() {
        this.mySpinner.loading = true;
        this.patientStore.getPatientHumorIndicatorsOutput = {chartIndicators:[]};
        await this.patientStore.getPatientHumorIndicators(this.patientId);
        this.mySpinner.loading = false;
    },
    data() {
        return {
            lastDays: [7, 15, 30], 
            options: {
                heigth: '200px',
                showArea: true,
                axisY: {
                    offset: 80,
                    showGrid: true,
                    labelInterpolationFnc: (value) => {
                        if (value % 1 == 0) {
                            return convertHumor(value);
                        }
                    },                    
                },
                axisX: {
                    showGrid: false
                },
            }
        }
    },      
}
</script>


<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_patients';
</style>
